import React from 'react'
import CommonInvoiceDetail from './CommonInvoiceDetail';

export default function ViewInvoice(props) {
    const {match:{params:{id}}} = props;
    return (
        <CommonInvoiceDetail id={id}/>
    )
}
